/**
 * Public (account-less) event registration constants (FR-282 to FR-288, design
 * section 41). Feature-local: nothing outside the events feature reads them.
 */

/** One localStorage key holding `{ [eventId]: { email, token } }` (A-305). */
export const GUEST_REGISTRATION_STORAGE_KEY = 'mnr.guest-event-registrations';

/** Header the status read carries the token in. Never the URL, so it stays out of logs. */
export const REGISTRATION_TOKEN_HEADER = 'X-Registration-Token';

/** The fragment parameter the confirmation email's link carries: `/e/:id#r=<token>`. */
export const REGISTRATION_TOKEN_FRAGMENT_PARAM = 'r';

/** Longest token accepted from the address bar; a real token is far shorter. */
export const REGISTRATION_TOKEN_MAX_LENGTH = 512;

/** Visible ASCII only, so a token read from the URL is always safe to send as a header value. */
export const REGISTRATION_TOKEN_PATTERN = /^[\x21-\x7E]+$/;

/** Match the Backend DTO (`guest-registration.dto.ts`) so a refusal there is a field error here. */
export const GUEST_FULL_NAME_MAX_LENGTH = 120;
export const GUEST_EMAIL_MAX_LENGTH = 254;

/** The throttler answers with the bare status and no `code`. */
export const HTTP_STATUS_TOO_MANY_REQUESTS = 429;

/**
 * Longest the status read may take. A remembered token is checked before the page
 * offers Register or Unregister, so a hung read must resolve quickly (to the
 * failed-read behaviour: Register shows, the entry is kept) rather than leave the
 * visitor with neither. Set on this request only; the shared client has no timeout.
 */
export const GUEST_STATUS_TIMEOUT_MS = 8_000;

/** How long a status read stays fresh, matching the member registration-status read. */
export const GUEST_STATUS_STALE_TIME_MS = 30_000;

/** `/e/:id` (ROUTES.EVENT_DETAIL), capturing the event id; the only path a registration link may arrive on. */
export const EVENT_DETAIL_PATH_PATTERN = /^\/e\/([^/?#]+)\/?$/;
